/**
 * @fileoverview PATCH handler for the "/apps/transformations/:transformation_id/rename" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationRename } from "./constants";
import type { Transformation } from "./types";
import type { RenameTransformationRequest } from "./types";

export const renameTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationRename,
  (props: RenameTransformationRequest): Promise<Transformation> => {
    return fetch(`/apps/transformations/${props.transformation_id}/rename`, "PATCH", props);
  }
);
